module.exports = __webpack_public_path__ + "static/media/search_uniscid.ccc5933f.svg";